import React from 'react';
import PropTypes from 'prop-types';
import downloadBlob from 'redux/helpers/downloadBlob';
import { ReactComponent as ProcessedIcon } from 'assets/svg/upload-processed.svg';
import { ReactComponent as ProcessingIcon } from 'assets/svg/upload-processing.svg';
import { ReactComponent as ErrorIcon } from 'assets/svg/upload-error.svg';
import { ReactComponent as DownloadIcon } from 'assets/svg/download-thick-bottom.svg';
import useDate, { DATE_TYPES } from 'hooks/useDate';
import { useAuth0 } from '@auth0/auth0-react';
import {
    MPADataSourcesMeasuresUploadItemHolder,
    DateHolder,
    StatusHolder,
    BinIconHolder,
    TableHeaderHolder,
    DownloadIconPositioner,
} from './MPADataSourcesMeasuresUploadItem.style';

const getUploadStatus = (status) => {
    if (status === 'error') {
        return <ErrorIcon />;
    }

    if (status === 'processing') {
        return <ProcessingIcon />;
    }

    return <ProcessedIcon />;
};

export const MPADataSourcesMeasuresUploadTableHeader = ({
    firstColumnLabel,
    secondColumnLabel,
    thirdColumnLabel,
}) => (
  <TableHeaderHolder>
    <span>{firstColumnLabel}</span>
    <span>{secondColumnLabel}</span>
    <span>{thirdColumnLabel}</span>
  </TableHeaderHolder>
);

MPADataSourcesMeasuresUploadTableHeader.propTypes = {
    firstColumnLabel: PropTypes.string,
    secondColumnLabel: PropTypes.string,
    thirdColumnLabel: PropTypes.string,
};

MPADataSourcesMeasuresUploadTableHeader.defaultProps = {
    firstColumnLabel: 'Filename',
    secondColumnLabel: 'Upload Date',
    thirdColumnLabel: 'Status',
};

const MPADataSourcesMeasuresUploadItem = ({
    id,
    createdAt,
    fileName,
    status,
    errorsFileUrl,
}) => {
    const { getAccessTokenSilently, logout } = useAuth0();

    const creationDate = new Date(createdAt);

    const downloadFile = () => {
        getAccessTokenSilently()
            .then((token) => {
                fetch(errorsFileUrl, {
                    method: 'GET',
                    headers: {
                        organization_slug: window.localStorage.getItem(
                            'MP_ORGANIZATION'
                        ),
                        Authorization: `Token token="${token}"`,
                    },
                })
                    .then((res) => res.blob())
                    .then((res) => downloadBlob(res, `error-${fileName}`));
            })
            .catch(() => logout({ returnTo: window.location.origin }));
    };

    return (
      <MPADataSourcesMeasuresUploadItemHolder id={id}>
        <strong>{fileName}</strong>
        <DateHolder>{useDate(creationDate, DATE_TYPES.long)}</DateHolder>
        <StatusHolder>
          {getUploadStatus(status)}

          {status === 'error' && !errorsFileUrl ? (
            <>Faulty file error</>
                ) : (
                  <>{status.charAt(0).toUpperCase() + status.slice(1)}</>
                )}
        </StatusHolder>
        <BinIconHolder>
          {status === 'error' && errorsFileUrl && (
            <DownloadIconPositioner>
              <DownloadIcon onClick={() => downloadFile()} />
            </DownloadIconPositioner>
                )}
        </BinIconHolder>
      </MPADataSourcesMeasuresUploadItemHolder>
    );
};

MPADataSourcesMeasuresUploadItem.propTypes = {
    id: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired,
    errorsFileUrl: PropTypes.string,
    status: PropTypes.string.isRequired,
};

MPADataSourcesMeasuresUploadItem.defaultProps = {
    errorsFileUrl: undefined,
};

export default MPADataSourcesMeasuresUploadItem;
